import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const appErrorLoader = () => import(/* webpackChunkName: "4-feat-app-error" */ './AppError');
export default lazyLoadOnRender({ loader: appErrorLoader });
